(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'userMenu',
            [
                'CHROME',
                UserMenuFactory
            ]
        );

    // Factory Method
    function UserMenuFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.MENU.USER + CHROME.POSTFIX
        };

    }
})();



